export enum UnitsOfMeasurementIcons {
  Bag = 'bag-filled',
  Each = 'each',
  Loads = 'loads',
  Pallets = 'pallets',
  Tons = 'ton',
  CubicMeters = 'cubic',
  Other = 'volume',
}

export enum UnitOfMeasurementId {
  Bag = 108,
  Each = 135,
  Loads = 802,
  Pallets = 282,
  Tons = 302,
  CubicMeters = 219,
}
